const configAggregator = (node) => {
    return {
        display: node.style.display
    }
}

export default configAggregator
